"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInView = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _reactIntersectionObserver = require("react-intersection-observer");
var _valuationUtilsComponent = require("@cian/valuation-utils-component");
var _ramda = require("ramda");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* istanbul ignore next */
const loadIntersectionObserver = (0, _ramda.identity)(() => Promise.resolve().then(() => _interopRequireWildcard(require('intersection-observer'))));
const hasNativeIntersectionObserver = typeof IntersectionObserver !== 'undefined';

/** Состояние модуля, показывает, загружался ли уже полифилл ранее */
let isPolyfillLoadedBefore = false;

/**
 * Хук оборачивает оригинальный useInView, добавляя загрузку полифилла при необходимости
 * В случае, если IntersectionObserver нативно не поддерживается и еще не загрузился, хук вернет пустую рефку
 * Пустая рефка не запускает использование IntersectionObserver, поэтому ошибка не возникает
 * */
const useInView = exports.useInView = hasNativeIntersectionObserver ? _reactIntersectionObserver.useInView : args => {
  const noopRef = (0, _react.useRef)(null);
  const result = (0, _reactIntersectionObserver.useInView)(args);
  const [isPolyfillLoaded, setPolyfillLoaded] = (0, _valuationUtilsComponent.useBooleanState)(isPolyfillLoadedBefore);
  (0, _react.useEffect)(() => {
    /** Если полифилл уже загружен, не нужно делать ничего лишнего */
    if (isPolyfillLoadedBefore) {
      return;
    }
    let componentStillMounted = true;
    loadIntersectionObserver().then(() => {
      isPolyfillLoadedBefore = true;

      /**
       * Если компонент к моменту загрузки полифилла уже размаунтился, стейт обновлять не нужно.
       * Сложно протестить
       * */
      /* istanbul ignore next */
      if (componentStillMounted) {
        setPolyfillLoaded();
      }
    }).catch(() => null);
    return () => {
      componentStillMounted = false;
    };
  }, [setPolyfillLoaded]);
  return isPolyfillLoaded ? result : _objectSpread(_objectSpread({}, result), {}, {
    ref: noopRef
  });
};